// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"242a053c","453":"ab72a9df"}[chunkId] + ".chunk.js";
};